import React from "react";
import {withNamespaces} from "react-i18next";
import HilightTable from "../../../../components/HilightTable";
import {FormCheck, Spinner} from "react-bootstrap";

const RoleClaimsTable = ({ t, roleClaims, permissionLevel, onChangeClaimsPermissionLevel }) => {

    const handleOnChangeRadio = (e, id, claimTypeId, levelPermissionId) => {
        e.preventDefault();
        // callback to page component
        onChangeClaimsPermissionLevel({
            id: id,
            claimTypeId: claimTypeId,
            levelPermissionId: levelPermissionId
        });
    };

    const columns = [
        {
            Header: 'key',
            accessor: 'claimType.key',
        },
        {
            Header: 'label',
            accessor: 'claimType.label'
        },
        {
            Header: 'actions',
            Cell: (props) => {
                const row = props.row.original;
                return (
                    <React.Fragment>

                        <FormCheck
                            inline
                            label="none"
                            type={'radio'}
                            id={`inline-${1}-1`}
                            checked={row.claimPermissionLevelId === 1}
                            onChange={(e) => handleOnChangeRadio(e, row.id, row.claimTypeId, 1)}
                        />
                        <FormCheck
                            inline
                            label="read"
                            type={'radio'}
                            id={`inline-${2}-2`}
                            checked={row.claimPermissionLevelId === 2}
                            onChange={(e) => handleOnChangeRadio(e, row.id, row.claimTypeId, 2)}
                        />
                        <FormCheck
                            inline
                            label="read write"
                            type={'radio'}
                            id={`inline-${3}-3`}
                            checked={row.claimPermissionLevelId === 3}
                            onChange={(e) => handleOnChangeRadio(e, row.id, row.claimTypeId, 3)}
                        />
                    </React.Fragment>
                )
            }
        }
    ];

    return (
        roleClaims ?
            roleClaims.length > 0 ?
                (
                    <HilightTable
                        columns={columns}
                        data={roleClaims}
                    />
                ) : (
                    <div className="text-center p-4">
                        <h3>{t('role-no-content')}</h3>
                    </div>
                ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>

            )
    )

};
export default withNamespaces()(RoleClaimsTable);
